"use strict"

const state = {
    combinationChartUpdateData: {},
}

const getters = {
    combinationChartUpdateData: state => state.combinationChartUpdateData,
}

const actions = {
    setCombinationChartToUpdate({commit, state}, idAndNames) {
        commit('setCombinationChartToUpdate', idAndNames)
    },
}

const mutations = {
    setCombinationChartToUpdate(state, idAndNames) {
        state.combinationChartUpdateData = {
            id: idAndNames.id,
            left: idAndNames.left,
            right: idAndNames.right,
        }
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/app/store/modules/combinationChart.js